import { config } from './config';
import MessageBusTransport from '@central-products/message-transport-bus';
import { bootstrap as boot } from '@central-products/bootstrapper';
import { feature as accountActions } from '@central-products/account-actions';
import { feature as casSessionManager } from '@central-products/cas-session-manager';
import { feature as webLoginPreferences } from '@central-products/web-login-preferences';
import { feature as loginFlow } from '@central-products/login-flow';
import { feature as registrationFlow } from '@central-products/registration-flow';
import { feature as graphqlClient } from '@central-products/graphql-client';
import { feature as ObSessionService } from '@central-products/obsession-service';
import { feature as AccountFlagsFeature } from '@central-products/account-flags';
import { feature as AccountFlagsFlowFeature } from '@central-products/account-flags-flow';
import { feature as SessionServiceFeature } from '@central-products/session-service';
import { feature as RecaptchaService } from '@central-products/recaptcha-service';
import { myAccount } from './features';

export async function bootstrap() {
  const { init, features } = boot(
    MessageBusTransport.getInstance(),
    [
      loginFlow,
      webLoginPreferences,
      casSessionManager,
      accountActions,
      registrationFlow,
      graphqlClient,
      myAccount,
      ObSessionService,
      AccountFlagsFeature,
      AccountFlagsFlowFeature,
      SessionServiceFeature,
      RecaptchaService,
    ],
    {
      [graphqlClient.name]: config.graphqlClient,
      [registrationFlow.name]: config.registrationFlow,
      [webLoginPreferences.name]: config.webLoginPreferences,
      [casSessionManager.name]: config.casSessionManager,
      [loginFlow.name]: config.loginFlow,
      [accountActions.name]: config.accountActions,
      [myAccount.name]: {},
      [ObSessionService.name]: config.obSessionService,
      [AccountFlagsFeature.name]: config.accountFlagsFeature,
      [AccountFlagsFlowFeature.name]: config.accountFlagsFlowFeature,
      [SessionServiceFeature.name]: config.sessionService,
      [RecaptchaService.name]: config.recaptchaService,
    }
  );

  await init();

  return features;
}
